import ConflictDeclarationsApi from '../../../../../core/api/ConflictDeclarationsApi'

export const PENDING_APPROVAL_START_EDITING_CONFLICT_DECLARATIONS = 'PENDING_APPROVAL_START_EDITING_CONFLICT_DECLARATIONS'
export const PENDING_APPROVAL_STOP_EDITING_CONFLICT_DECLARATIONS = 'PENDING_APPROVAL_STOP_EDITING_CONFLICT_DECLARATIONS'
export const PENDING_APPROVAL_CANCEL_EDITING_CONFLICT_DECLARATIONS = 'PENDING_APPROVAL_CANCEL_EDITING_CONFLICT_DECLARATIONS'
export const PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_FETCHED_CONFLICT_DECLARATIONS = 'PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_FETCHED_CONFLICT_DECLARATIONS'
export const PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_CONFLICT_DECLARATION_SELECTED_CHANGED = 'PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_CONFLICT_DECLARATION_SELECTED_CHANGED'
export const PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_NO_CONFLICT_SELECTED = 'PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_NO_CONFLICT_SELECTED'

export const events = {
  set: {
    noConflict: 'PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_NO_CONFLICT_SELECTED'
  }
}
const conflictDeclarationsApi = new ConflictDeclarationsApi()

const { set } = events
export const actions = {
  set: {
    noConflict: () => ({
      type: set.noConflict
    })
  }
}

export const startEditingDeclarations = () => ({
  type: PENDING_APPROVAL_START_EDITING_CONFLICT_DECLARATIONS
})

export const cancelEditingDeclarations = () => ({
  type: PENDING_APPROVAL_CANCEL_EDITING_CONFLICT_DECLARATIONS
})

export function fetchConflictDeclarations () {
  const request = conflictDeclarationsApi.fetchingConflictDeclarations()

  return (dispatch) => {
    request.then(function (response) {
      dispatch(conflictDeclarationsApi.handleResponse(PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_FETCHED_CONFLICT_DECLARATIONS, response))
    })
  }
}

export const conflictDeclarationSelectedChanged = (conflictDeclaration) => ({
  type: PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_CONFLICT_DECLARATION_SELECTED_CHANGED,
  conflictDeclaration
})

export const stopEditingDeclarations = () => ({
  type: PENDING_APPROVAL_STOP_EDITING_CONFLICT_DECLARATIONS
})

export const noConflictSelected = () => ({
  type: PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_NO_CONFLICT_SELECTED
})
